import { render, staticRenderFns } from "./SchedulerCalendar.vue?vue&type=template&id=8dc15fe4&"
import script from "./SchedulerCalendar.vue?vue&type=script&lang=js&"
export * from "./SchedulerCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports